import React from 'react';
import { useLanguage } from '../../../features/language/useLanguage';

interface WorkOrdersHeaderProps {
  label: string;
  onAction: () => void;
  canWrite?: boolean;
}

export const WorkOrdersHeader: React.FC<WorkOrdersHeaderProps> = ({ label, onAction, canWrite = true }) => {
  const { t } = useLanguage();
  return (
    <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
      <h1 className="text-2xl font-semibold text-gray-900">{t('workOrders.page.title')}</h1>
      {canWrite && (
        <button
          data-test-id="wo-create-button"
          onClick={onAction}
          className="w-full sm:w-auto px-4 py-2 bg-primary-600 text-white rounded-md hover:bg-primary-700 shadow-sm disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {label}
        </button>
      )}
    </div>
  );
};
